import { deleteApi, getApi, postApi, putApi } from "./http.service";

export const createNewShop=async(payload:any)=>{
    return postApi('shop',payload);
}

export const getShopById=async(id:any)=>{
    return getApi('shop/'+id);
}

export const getAllShops=async()=>{
    return getApi('shop');
}

export const updateShopById=async(id:any, payload:any)=>{
    return putApi('shop/'+id, payload);
}

export const deleteShopById=async(id:any)=>{
    return deleteApi('shop/'+id);
}